/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import { GoogleAnalyticsConfig } from '@eagle/core-data-types';
import { FC, ReactNode, useEffect, type JSX } from 'react';
import ReactGA from 'react-ga4';
import { InitOptions } from 'react-ga4/types/ga4';
import { useLocation } from 'react-router-dom';
import { trackPage } from '../../util';
import { RouteInfo } from '../page-content';

export const GoogleAnalyticsTrackingWrapper: FC<{ children: ReactNode; routes: RouteInfo[]; options?: GoogleAnalyticsConfig }> = ({ children, routes, options }): JSX.Element => {
  const location = useLocation();

  if (!options) return <>{children}</>;

  const initGaOptions: InitOptions = {
    trackingId: options.trackingId,
  };

  const initTagOptions: InitOptions = {
    trackingId: options.tagManagerId || '',
  };

  try {
    ReactGA.initialize([initGaOptions, initTagOptions]);
  } catch (error) {
    console.error('Failed to initialize analytics:', error);
  }

  useEffect(() => {
    trackPage(location.pathname, routes);
  }, [location]);

  return <>
    {children}
  </>;
};
